import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useEffect, useMemo, useState } from 'react';
import { usePurchaseMotionForAssignability } from '../../../hooks/usePurchaseMotionForAssignability';
import { PurchaseMotions } from '../../../types/PurchaseMotion';
import { potentiallyOverridenAssignability } from '../../../utils/talkToSales';
import { isUpgradePoint } from '../../../utils/ums';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { PricingPageRedirectButton } from '../PricingPageRedirectButton/PricingPageRedirectButton';
import CommModalContainer from './CommModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TalkToSalesButtonBase = props => {
  const {
    apiName,
    children,
    isAssignable: originalAssignability,
    level,
    location,
    trackingData,
    uiButtonProps,
    onClick
  } = props;
  const [showModal, setShowModal] = useState(false);
  const isAssignable = useMemo(() => potentiallyOverridenAssignability(originalAssignability), [originalAssignability]);
  const {
    loading,
    purchaseMotion
  } = usePurchaseMotionForAssignability({
    isAssignable,
    apiName
  });
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick(PurchaseMotions.TALK_TO_SALES);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (!loading) {
      track('contactSalesButtonInteraction', Object.assign({
        action: 'viewed'
      }, getTrackingProperties({
        apiName,
        trackingData
      })));
      if (isUpgradePoint(location)) {
        track('interaction', Object.assign({
          action: 'viewed talk to sales',
          isAssignable: purchaseMotion === PurchaseMotions.TALK_TO_SALES,
          isPrimaryCta: level === 1,
          isSecondaryCta: level === 2
        }, getTrackingProperties({
          apiName,
          trackingData
        })));
      }
    }
  }, [loading, apiName, level, location, purchaseMotion, trackingData]);
  if (purchaseMotion === PurchaseMotions.PRICING_PAGE_REDIRECT) {
    // A pp redirect motion will only be returned for users in Russia
    return /*#__PURE__*/_jsx(PricingPageRedirectButton, Object.assign({}, props));
  }
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, uiButtonProps, {
      loading: loading,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.talkToSales"
      })
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showModal && /*#__PURE__*/_jsx(CommModalContainer, {
      apiName: apiName,
      trackingData: trackingData,
      isAssignable: purchaseMotion === PurchaseMotions.TALK_TO_SALES,
      onClose: handleClose
    }), /*#__PURE__*/_jsx(Button, Object.assign({
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      }
    }, uiButtonProps, {
      onClick: handleClick,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.talkToSales"
      })
    }))]
  });
};
export const TalkToSalesButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.TALK_TO_SALES_BUTTON,
  children: /*#__PURE__*/_jsx(TalkToSalesButtonBase, Object.assign({}, props))
});